export enum ColorType {
  HEX = 'hex',
  RGB = 'rgb',
  HSL = 'hsl',
  CMYK = 'cmyk',
  UNKNOWN = 'unknown',
}

export interface IHSL {
  h: number;
  s: number;
  l: number;
  a?: number;
}

export interface IHSV {
  h: number;
  s: number;
  v: number;
  a?: number;
}

export interface IRGB {
  r: number;
  g: number;
  b: number;
  a?: number;
}

export interface ICMYK {
  c: number;
  m: number;
  y: number;
  k: number;
}

export interface IPickerColor {
  hsl: IHSL;
  hex: string;
  rgb: IRGB;
  hsv?: IHSV;
  oldHue?: string;
  source?: string;
}
